export default __webpack_public_path__ + "static/media/FreeRead.75d7070c.png";